import { CircularProgress, Typography } from '@material-ui/core'
import styled from 'styled-components'

const Container = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  padding-top: 5px;
  align-items: center;
  justify-content: center;
  align-self: center;
`

const TopSection = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;
`

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
`

const BottomSection = styled.div`
  display: flex;
  flex: 1;
  width: 100%;
  margin-top: 14px;
`

interface IconCardProps {
  icon?: React.ReactNode
  info: string
  value: string
  loading?: boolean
  bottomComponent?: React.ReactNode
}

export const DataVariantionIndicator = () => {}

export default ({
  icon = null,
  info,
  value,
  loading = false,
  bottomComponent = null,
}: IconCardProps) => {
  if (loading) {
    return (
      <Container>
        <CircularProgress />
      </Container>
    )
  }
  return (
    <Container>
      <TopSection>
        <TextContainer>
          <Typography variant='subtitle2' color='textSecondary'>
            {info}
          </Typography>
          <Typography
            variant='h4'
            color='textPrimary'
            style={{ marginBottom: 15, marginTop: 5 }}
            noWrap
          >
            {value}
          </Typography>
        </TextContainer>
        {icon}
      </TopSection>
      {bottomComponent && <BottomSection>{bottomComponent}</BottomSection>}
    </Container>
  )
}
